import type { Asset as ContentfulAsset, Entry, EntrySkeletonType } from 'contentful'
import type {
  TypeBookNotesSkeleton,
  TypeBookNotesWithoutUnresolvableLinksResponse,
  TypeCaseStudySkeleton,
  TypeCaseStudyWithoutUnresolvableLinksResponse,
  TypeCertificateSkeleton,
  TypeCertificateWithoutUnresolvableLinksResponse,
  TypeCurriculumMapSkeleton,
  TypeCurriculumMapWithoutUnresolvableLinksResponse,
  TypeDiscoGuideSkeleton,
  TypeDiscoGuideWithoutUnresolvableLinksResponse,
  TypeLessonDataSkeleton,
  TypeLessonDataWithoutUnresolvableLinksResponse,
  TypeLessonPreviewSkeleton,
  TypeLessonPreviewWithoutUnresolvableLinksResponse,
  TypeLessonResourceSkeleton,
  TypeLessonResourceWithoutUnresolvableLinksResponse,
  TypeMathseedsPrimeLessonSkeleton,
  TypeMathseedsPrimeLessonWithoutUnresolvableLinksResponse,
  TypeMathseedsPrimeLessonResourceSkeleton,
  TypeMathseedsPrimeLessonResourceWithoutUnresolvableLinksResponse,
  TypePrecinctResourceSkeleton,
  TypePrecinctResourceWithoutUnresolvableLinksResponse,
  TypePrintablesLibraryBookSkeleton,
  TypePrintablesLibraryBookWithoutUnresolvableLinksResponse,
  TypePrintablesLibrarySetSkeleton,
  TypePrintablesLibrarySetWithoutUnresolvableLinksResponse,
  TypePrintablesQuickFiltersSkeleton,
  TypePrintablesQuickFiltersWithoutUnresolvableLinksResponse,
  TypeResearchReportSkeleton,
  TypeResearchReportWithoutUnresolvableLinksResponse,
  TypeRolloverGuideSkeleton,
  TypeRolloverGuideWithoutUnresolvableLinksResponse,
  TypeSummerGuideSkeleton,
  TypeSummerGuideWithoutUnresolvableLinksResponse,
  TypeTeacherGuideSkeleton,
  TypeTeacherGuideWithoutUnresolvableLinksResponse,
  TypeTeacherResourceActivitySkeleton,
  TypeTeacherResourceActivityWithoutUnresolvableLinksResponse,
  TypeTeacherResourceCategorySkeleton,
  TypeTeacherResourceCategoryWithoutUnresolvableLinksResponse,
  TypeTeacherResourceFilesSkeleton,
  TypeTeacherResourceFilesWithoutUnresolvableLinksResponse,
  TypeQuickStartResourceSkeleton,
  TypeQuickStartResourceWithoutUnresolvableLinksResponse,
  TypeHomeschoolMaxWebinarSkeleton,
} from 'teacher-ui-client/contentful-client/generated-types'

export type Asset = ContentfulAsset<'WITHOUT_UNRESOLVABLE_LINKS', string>

import * as TypePredicates from 'teacher-ui-client/contentful-client/generated-types'

export const isTypeBookNotes = TypePredicates.isTypeBookNotes<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeCaseStudy = TypePredicates.isTypeCaseStudy<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeCertificate = TypePredicates.isTypeCertificate<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeCurriculumMap = TypePredicates.isTypeCurriculumMap<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeDiscoGuide = TypePredicates.isTypeDiscoGuide<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeLessonData = TypePredicates.isTypeLessonData<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeLessonPreview = TypePredicates.isTypeLessonPreview<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeLessonResource = TypePredicates.isTypeLessonResource<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeMathseedsPrimeLesson = TypePredicates.isTypeMathseedsPrimeLesson<
  'WITHOUT_UNRESOLVABLE_LINKS',
  string
>
export const isTypeMathseedsPrimeLessonResource = TypePredicates.isTypeMathseedsPrimeLessonResource<
  'WITHOUT_UNRESOLVABLE_LINKS',
  string
>
export const isTypePrecinctResource = TypePredicates.isTypePrecinctResource<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypePrintablesLibraryBook = TypePredicates.isTypePrintablesLibraryBook<
  'WITHOUT_UNRESOLVABLE_LINKS',
  string
>
export const isTypePrintablesLibrarySet = TypePredicates.isTypePrintablesLibrarySet<
  'WITHOUT_UNRESOLVABLE_LINKS',
  string
>
export const isTypePrintablesQuickFilters = TypePredicates.isTypePrintablesQuickFilters<
  'WITHOUT_UNRESOLVABLE_LINKS',
  string
>
export const isTypeResearchReport = TypePredicates.isTypeResearchReport<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeSummerGuide = TypePredicates.isTypeSummerGuide<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeTeacherGuide = TypePredicates.isTypeTeacherGuide<'WITHOUT_UNRESOLVABLE_LINKS', string>
export const isTypeTeacherResourceActivity = TypePredicates.isTypeTeacherResourceActivity<
  'WITHOUT_UNRESOLVABLE_LINKS',
  string
>
export const isTypeTeacherResourceCategory = TypePredicates.isTypeTeacherResourceCategory<
  'WITHOUT_UNRESOLVABLE_LINKS',
  string
>
export const isTypeTeacherResourceFiles = TypePredicates.isTypeTeacherResourceFiles<
  'WITHOUT_UNRESOLVABLE_LINKS',
  string
>

export const isTypeQuickStartResource = TypePredicates.isTypeQuickStartResource<'WITHOUT_UNRESOLVABLE_LINKS', string>

export type BookNotesSkeleton = TypeBookNotesSkeleton
export type BookNotesEntry = TypeBookNotesWithoutUnresolvableLinksResponse
export type CaseStudySkeleton = TypeCaseStudySkeleton
export type CaseStudyEntry = TypeCaseStudyWithoutUnresolvableLinksResponse
export type CertificateSkeleton = TypeCertificateSkeleton
export type CertificateEntry = TypeCertificateWithoutUnresolvableLinksResponse
export type CurriculumMapSkeleton = TypeCurriculumMapSkeleton
export type CurriculumMapEntry = TypeCurriculumMapWithoutUnresolvableLinksResponse
export type DiscoGuideSkeleton = TypeDiscoGuideSkeleton
export type DiscoGuideEntry = TypeDiscoGuideWithoutUnresolvableLinksResponse
export type LessonDataSkeleton = TypeLessonDataSkeleton
export type LessonDataEntry = TypeLessonDataWithoutUnresolvableLinksResponse
export type LessonPreviewSkeleton = TypeLessonPreviewSkeleton
export type LessonPreviewEntry = TypeLessonPreviewWithoutUnresolvableLinksResponse
export type LessonResourceSkeleton = TypeLessonResourceSkeleton
export type LessonResourceEntry = TypeLessonResourceWithoutUnresolvableLinksResponse
export type MathseedsPrimeLessonSkeleton = TypeMathseedsPrimeLessonSkeleton
export type MathseedsPrimeLessonEntry = TypeMathseedsPrimeLessonWithoutUnresolvableLinksResponse
export type MathseedsPrimeLessonResourceSkeleton = TypeMathseedsPrimeLessonResourceSkeleton
export type MathseedsPrimeLessonResourceEntry = TypeMathseedsPrimeLessonResourceWithoutUnresolvableLinksResponse
export type PrecinctResourceSkeleton = TypePrecinctResourceSkeleton
export type PrecinctResourceEntry = TypePrecinctResourceWithoutUnresolvableLinksResponse
export type PrintablesLibraryBookSkeleton = TypePrintablesLibraryBookSkeleton
export type PrintablesLibraryBookEntry = TypePrintablesLibraryBookWithoutUnresolvableLinksResponse
export type PrintablesLibrarySetSkeleton = TypePrintablesLibrarySetSkeleton
export type PrintablesLibrarySetEntry = TypePrintablesLibrarySetWithoutUnresolvableLinksResponse
export type PrintablesQuickFiltersSkeleton = TypePrintablesQuickFiltersSkeleton
export type PrintablesQuickFiltersEntry = TypePrintablesQuickFiltersWithoutUnresolvableLinksResponse
export type ResearchReportSkeleton = TypeResearchReportSkeleton
export type ResearchReportEntry = TypeResearchReportWithoutUnresolvableLinksResponse
export type RolloverGuideSkeleton = TypeRolloverGuideSkeleton
export type RolloverGuideEntry = TypeRolloverGuideWithoutUnresolvableLinksResponse
export type SummerGuideSkeleton = TypeSummerGuideSkeleton
export type SummerGuideEntry = TypeSummerGuideWithoutUnresolvableLinksResponse
export type TeacherGuideSkeleton = TypeTeacherGuideSkeleton
export type TeacherGuideEntry = TypeTeacherGuideWithoutUnresolvableLinksResponse
export type TeacherResourceActivitySkeleton = TypeTeacherResourceActivitySkeleton
export type TeacherResourceActivityEntry = TypeTeacherResourceActivityWithoutUnresolvableLinksResponse
export type TeacherResourceCategorySkeleton = TypeTeacherResourceCategorySkeleton
export type TeacherResourceCategoryEntry = TypeTeacherResourceCategoryWithoutUnresolvableLinksResponse
export type TeacherResourceFilesSkeleton = TypeTeacherResourceFilesSkeleton
export type TeacherResourceFilesEntry = TypeTeacherResourceFilesWithoutUnresolvableLinksResponse
export type QuickStartResourceSkeleton = TypeQuickStartResourceSkeleton
export type QuickStartResourceEntry = TypeQuickStartResourceWithoutUnresolvableLinksResponse
export type HomeschoolMaxWebinarSkeleton = TypeHomeschoolMaxWebinarSkeleton

export type ProductUnderscored = 'reading_eggs' | 'reading_eggspress' | 'fast_phonics' | 'mathseeds'

export function getId(entry: Entry<EntrySkeletonType>) {
  return entry.sys.id
}

export type PrecinctResourceType = 'training_video'

export const LessonResourceType = {
  WEEKLY_TEACHING_GUIDE: 'weekly_teaching_guide',
  PHONICS: 'phonics',
  HANDWRITING: 'handwriting',
  HANDWRITING_NSW: 'handwriting_nsw',
  HANDWRITING_QLD: 'handwriting_qld',
  HANDWRITING_VIC: 'handwriting_vic',
  CURSIVE: 'cursive',
  STUDENT_PDF: 'student_pdf',
  ES_STUDENT_PDF: 'es_student_pdf',
  TEACHER_PDF: 'teacher_pdf',
  SKILLS: 'skills',
  PROBLEM_SOLVING: 'problem_solving',
  TEACHING_POWERPOINT: 'teaching_powerpoint',
} as const

export type LessonResourceType = ValuesOf<typeof LessonResourceType>

export function isLessonResourceType(maybe: unknown): maybe is LessonResourceType {
  return Object.values(LessonResourceType).includes(maybe as LessonResourceType)
}

export enum LessonDataField {
  Title = 'title',
  Precinct = 'precinct',
  ActivityNumber = 'activityNumber',
  Quiz = 'quiz',
  Map = 'map',

  FocusSounds = 'focusSounds',
  WordsRead = 'wordsRead',
  Alternatives = 'alternatives',
  WordCount = 'wordCount',
  Phase = 'phase',

  Vocabulary = 'vocabulary',

  HighFrequencySightWords = 'highFrequencySightWords',

  PhonicallyDecodableWords = 'phonicallyDecodableWords',
  PhonicLettersAndSounds = 'phonicLettersAndSounds',

  Skills = 'skills',
  ReadingLevel = 'readingLevel',

  FocusSoundWords = 'focusSoundWords',
  Challenge = 'challenge',

  TextType = 'textType',
  MapTopic = 'mapTopic',
  FocusSummary = 'focusSummary',
  FocusActivities = 'focusActivities',
}
